import React from 'react';
import { Image, List, ListItem } from '@chakra-ui/react';

import * as images from '../images';

import {
  SmartphoneBr,
  HeadingText,
  SubtitleText,
  HighlightedText,
  ParagraphText,
  Section,
} from './commonComponents';

const ProblemSection = (): JSX.Element => (
  <Section bgColor="#eef8fa">
    <HeadingText fontSize={{ base: '3xl', sm: '4xl' }}>
      こんな
      <HighlightedText>お悩み</HighlightedText>
      <SmartphoneBr />
      ありませんか？
      <SubtitleText>problem</SubtitleText>
    </HeadingText>
    <List
      display="flex"
      justifyContent="center"
      // TODO: 他のflexboxで分岐不要なのにここだけnowrap指定をなくしたい
      flexWrap={{ base: 'wrap', sm: 'nowrap' }}
      maxW="900px"
      margin="auto"
      paddingTop="20px"
      textAlign="center"
    >
      <ListItem
        w="100%"
        display="flex"
        flexDirection="column"
        alignItems="center"
      >
        <Image src={images.freshGradsWelcome} width="160px" alt="" />
        <ParagraphText>
          <HighlightedText>理系学部生</HighlightedText>
          を
          <br />
          歓迎なのか分からない
        </ParagraphText>
      </ListItem>
      <ListItem
        w="100%"
        display="flex"
        flexDirection="column"
        alignItems="center"
      >
        <Image src={images.scienceMajors} width="160px" alt="" />
        <ParagraphText>
          研究が本格化しておらず
          <br />
          <HighlightedText>伝え方に悩む</HighlightedText>
        </ParagraphText>
      </ListItem>
      <ListItem
        w="100%"
        display="flex"
        flexDirection="column"
        alignItems="center"
      >
        <Image src={images.studentsInClass} width="160px" alt="" />
        <ParagraphText>
          講義・実験で忙しく
          <br />
          <HighlightedText>就活に専念できない</HighlightedText>
        </ParagraphText>
      </ListItem>
      <ListItem
        w="100%"
        display="flex"
        flexDirection="column"
        alignItems="center"
      >
        <Image src={images.schoolFilter} width="160px" alt="" />
        <ParagraphText>
          <HighlightedText>学歴フィルター</HighlightedText>
          が
          <br />
          あるのか分からない
        </ParagraphText>
      </ListItem>
    </List>
  </Section>
);

export default ProblemSection;
